module.exports = __webpack_public_path__ + "img/img015.886eece1.png";